/**
 * Asynchronously loads the component for AppointmentWidgetContainer
 */
import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./AppointmentWidgetContainer'),
  loading: () => null,
});
